import { Int32Histogram } from 'hdr-histogram-js'
import { SerializedHistogram } from '../domain/SerializedHistogram'

export const importHdrHistogram = (serialized: SerializedHistogram | null): Int32Histogram | null => {
    if (!serialized || !serialized.v) {
        return null
    }

    const { ltv = 1, htv = 60000, sf = 2, v: values } = serialized

    const histogram = new Int32Histogram(ltv, htv, sf)
    histogram.autoResize = false

    let index = 0
    values.map(count => {
        if (count < 0) {
            index += Math.abs(count)

            return
        }

        histogram.setCountAtIndex(index, count)

        index++
    })

    // magic from components/profiler/node_modules/hdr-histogram-js/src/AbstractHistogram.encoding.ts
    histogram.establishInternalTackingValues()

    return histogram
}
